"use client";

import { c as _c } from "react/compiler-runtime";
import { Faqs, FaqsRef } from "@/components/common/faqs";
import { HaveMoreQuestionCard } from "@/components/common/have-more-question-card";
import { FaqLoader } from "@/components/loadings/faq-loader";
import { Section } from "@/components/section";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Skeleton } from "@/components/ui/skeleton";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { FaqType } from "@/graphql/queries/faqs-query";
import { useFaqsTypesQuery } from "@/hooks/cart/use-api-query";
import { useFaqParams } from "@/hooks/useFaqParams";
import { useMemo } from "react";
import { Suspense, useRef } from "react";
type FrequentlyAskedQuestionsProps = {
  section: PageSections;
  data: {
    seoHeading?: string;
    heading: string;
    buttonText: string;
    buttonAction: string;
    serviceId: string;
    withExam: boolean;
    serviceFlags: string[];
    hasGrouped: boolean;
    faqs: {
      question: string;
      answer: string;
    }[];
  };
};
const EXCLUDE_FAQ_TYPES = [FaqType.CONSULTING, FaqType.GENERAL];
const FrequentlyAskedQuestions = t0 => {
  const $ = _c(23);
  const {
    section,
    data
  } = t0;
  const {
    faqType,
    slug,
    country,
    city
  } = useFaqParams();
  const {
    data: list,
    isLoading
  } = useFaqsTypesQuery(slug, country, city, faqType !== FaqType.COURSES);
  const faqsRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = value => {
      faqsRef.current?.refetch({
        faqType: value
      });
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleTabChange = t1;
  list?.data;
  let t2;
  if ($[1] !== list?.data) {
    const filteredItems = list?.data?.filter(_temp) ?? [];
    t2 = [...filteredItems.filter(_temp2), ...filteredItems.filter(_temp3)].map(_temp4);
    $[1] = list?.data;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const items = t2;
  let t3;
  if ($[3] !== faqType || $[4] !== isLoading || $[5] !== items) {
    t3 = faqType === FaqType.COURSES && <><Tabs defaultValue={faqType} onValueChange={handleTabChange} orientation="vertical" className="sticky top-32"><TabsList className="ring-border hidden min-w-45 gap-2 p-2 ring md:flex">{items.map(_temp5)}{isLoading && <div className="flex flex-col gap-2">{[...Array(2)].map(_temp6)}</div>}</TabsList></Tabs><div className="w-full md:hidden"><Select items={items} defaultValue={faqType} onValueChange={value_0 => handleTabChange(value_0 as FaqType)}><SelectTrigger className="w-full" aria-label="Course Type"><SelectValue /></SelectTrigger><SelectContent alignItemWithTrigger={false} align="start" className="w-full">{items.map(_temp7)}</SelectContent></Select></div></>;
    $[3] = faqType;
    $[4] = isLoading;
    $[5] = items;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FaqLoader />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = data?.seoHeading || data?.heading;
  let t6;
  if ($[8] !== t5) {
    t6 = <div className="min-w-0 flex-1"><Suspense fallback={t4}><Faqs ref={faqsRef} heading={t5} /></Suspense></div>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== data.hasGrouped || $[11] !== data.serviceId) {
    t7 = !data?.hasGrouped && <HaveMoreQuestionCard serviceId={data.serviceId} />;
    $[10] = data.hasGrouped;
    $[11] = data.serviceId;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t3 || $[14] !== t6 || $[15] !== t7) {
    t8 = <div className="flex flex-col items-start justify-start gap-5 sm:flex-row">{t3}{t6}{t7}</div>;
    $[13] = t3;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== data.heading || $[18] !== data.seoHeading || $[19] !== section.sectionClass || $[20] !== section.sectionId || $[21] !== t8) {
    t9 = <Section id={section.sectionId} className={section.sectionClass} title={data.heading} seoTitle={data.seoHeading}>{t8}</Section>;
    $[17] = data.heading;
    $[18] = data.seoHeading;
    $[19] = section.sectionClass;
    $[20] = section.sectionId;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
};
export default FrequentlyAskedQuestions;
function _temp(item) {
  return !EXCLUDE_FAQ_TYPES.includes(item.value as FaqType);
}
function _temp2(item_0) {
  return item_0.value !== "FAQ_PAYMENT";
}
function _temp3(item_1) {
  return item_1.value === "FAQ_PAYMENT";
}
function _temp4(itm) {
  return {
    label: itm.name,
    value: itm.value
  };
}
function _temp5(item_2) {
  return <TabsTrigger key={item_2.value} value={item_2.value as FaqType} className="px-3 py-2">{item_2.label}</TabsTrigger>;
}
function _temp6(_, i) {
  return <div key={i} className="flex flex-col gap-2"><Skeleton className="h-10 w-full min-w-25" /></div>;
}
function _temp7(item_3) {
  return <SelectItem key={item_3.value} value={item_3.value}>{item_3.label}</SelectItem>;
}